import React from 'react';

import { ThemeProvider } from '@mui/material/styles';

import theme from '@/theme';
import GlobalContext from '../GlobalContext';
import { LendGlobalContextProvider } from './LendGlobalContext';

type Err = Error | string | null;

interface GlobalContextAttrs {
  children: React.ReactNode;
  error: Err;
  setError: (error: Err) => void;
  isTWA: boolean;
}

export default function GlobalContextProviders({ children, error, setError, isTWA }: GlobalContextAttrs) {
  const memoizedContextValue = React.useMemo(() => ({ error, setError, isTWA }), [error, setError, isTWA]);

  return (
    <GlobalContext.Provider value={memoizedContextValue}>
      <LendGlobalContextProvider>
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
      </LendGlobalContextProvider>
    </GlobalContext.Provider>
  );
}
